// extracted by mini-css-extract-plugin
export default {"beginAddPage":"create-page_beginAddPage__kkWnF","createNewPageText":"create-page_createNewPageText__uQCUh"};